
import { Component, Vue } from 'vue-property-decorator'
import { getUserCouponPage, invalidateUserCoupon, restoreUserCoupon, IUserCouponAdmin } from '@/api/userCoupon'
import UserNameRemark from '@/components/UserNameRemark/index.vue'
import { scheduleElTableFixedSync } from '@/utils/elTableFixedSync'

@Component({
  name: 'UserCouponRecord',
  components: { UserNameRemark },
})
export default class extends Vue {
  private loading: boolean = false
  private list: IUserCouponAdmin[] = []
  private total: number = 0
  private restoreDialogVisible: boolean = false
  private restoreForm: { id: number | null; expireTime: string } = {
    id: null,
    expireTime: ''
  }

  private query: {
    pageNum: number
    pageSize: number
    phone: string
    couponName: string
    status: number | null
  } = {
    pageNum: 1,
    pageSize: 10,
    phone: '',
    couponName: '',
    status: null
  }

  mounted() {
    this.loadList()
    window.addEventListener('resize', this.scheduleTableLayout)
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.scheduleTableLayout)
  }

  private scheduleTableLayout() {
    scheduleElTableFixedSync(this, 'mainTable')
  }

  private async loadList() {
    this.loading = true
    try {
      const params: any = {
        pageNum: this.query.pageNum,
        pageSize: this.query.pageSize
      }
      if (this.query.phone) params.phone = this.query.phone
      if (this.query.couponName) params.couponName = this.query.couponName
      if (this.query.status !== null && this.query.status !== undefined) {
        params.status = this.query.status
      }
      const res: any = await getUserCouponPage(params)
      if (String(res.data.code) === '1' && res.data.data) {
        this.list = res.data.data.records || res.data.data.list || res.data.data.data || []
        this.total = res.data.data.total || 0
      } else {
        this.list = []
        this.total = 0
      }
    } catch (e) {
      this.list = []
      this.total = 0
    } finally {
      this.loading = false
      this.scheduleTableLayout()
    }
  }

  private tableIndex(index: number) {
    return (this.query.pageNum - 1) * this.query.pageSize + index + 1
  }

  private handleSearch() {
    this.query.pageNum = 1
    this.loadList()
  }

  private handleReset() {
    this.query.phone = ''
    this.query.couponName = ''
    this.query.status = null
    this.query.pageNum = 1
    this.loadList()
  }

  private handleSizeChange(size: number) {
    this.query.pageSize = size
    this.loadList()
  }

  private handlePageChange(page: number) {
    this.query.pageNum = page
    this.loadList()
  }

  private async handleInvalidate(row: IUserCouponAdmin) {
    try {
      await this.$confirm('确定将该优惠券记录设为失效吗？', '提示', {
        type: 'warning'
      })
    } catch (e) {
      return
    }
    try {
      await invalidateUserCoupon(row.id)
      this.$message.success('操作成功')
      this.loadList()
    } catch (e) {
      // ignore
    }
  }

  private async handleRestore(row: IUserCouponAdmin) {
    this.restoreForm = {
      id: row.id,
      expireTime: ''
    }
    this.restoreDialogVisible = true
  }

  private async confirmRestore() {
    if (!this.restoreForm || !this.restoreForm.id) return
    if (!this.restoreForm.expireTime) {
      this.$message.warning('请选择过期时间')
      return
    }
    // 简单校验：必须是未来时间
    const ts = new Date(this.restoreForm.expireTime.replace(/-/g, '/')).getTime()
    if (!isNaN(ts) && ts <= Date.now()) {
      this.$message.warning('过期时间必须大于当前时间')
      return
    }
    try {
      await restoreUserCoupon(this.restoreForm.id, this.restoreForm.expireTime)
      this.$message.success('操作成功')
      this.restoreDialogVisible = false
      this.loadList()
    } catch (e) {
      // ignore
    }
  }

  private formatDate(v?: string) {
    if (!v) return ''
    return String(v).replace('T', ' ').slice(0, 19)
  }
}
